var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageUploadNumber2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#EAF1F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4605 35V33.17L25.0805 26.45C28.2905 23.57 29.4605 21.95 29.4605 19.85C29.4605 17.39 27.5105 15.83 25.2305 15.83C22.8305 15.83 21.2705 17.09 19.5905 19.43L17.8505 18.17C19.7405 15.35 21.7205 13.7 25.4105 13.7C29.1905 13.7 31.9205 16.22 31.9205 19.64V19.7C31.9205 22.76 30.3005 24.65 26.6105 27.86L21.0005 32.84H32.1305V35H17.4605Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUploadNumber2Icon);
export default __webpack_public_path__ + "static/media/image_upload_number2_icon.b104085b0e373ecb78235eb37e7fa8f0.svg";
export { ForwardRef as ReactComponent };